import { createApp } from "vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import "./assets/styles/tokens.scss";
import "./assets/styles/typography.scss";
import { auth } from "./firebase";

// Components
import App from "./App.vue";
let app;

auth.onAuthStateChanged((user) => {
  if (user) {
    store.dispatch("setUser", user);
  }
  if (!app) {
    app = createApp(App).use(router).use(store).use(vuetify).mount("#app");
  }
});
